import styled from "styled-components";
import imageBoxMixin from "../../../mixins/imageBox";
import isPropValid from "@emotion/is-prop-valid";
export const CssSizedImage = styled.img.withConfig({
    shouldForwardProp: isPropValid,
}) `
  height: 100%;
  width: 100%;
  max-width: unset;
  ${imageBoxMixin};
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3NzU2l6ZWRJbWFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ltYWdlQm94L3N0eWxlZC9Dc3NTaXplZEltYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sYUFBcUMsTUFBTSwwQkFBMEIsQ0FBQztBQUM3RSxPQUFPLFdBQVcsTUFBTSx3QkFBd0IsQ0FBQztBQUVqRCxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUM7SUFDakQsaUJBQWlCLEVBQUUsV0FBVztDQUMvQixDQUFDLENBQW9COzs7O0lBSWxCLGFBQWE7Q0FDaEIsQ0FBQyJ9